import { render } from "./ServerStatus.vue?vue&type=template&id=cf994ca2&ts=true"
import script from "./ServerStatus.vue?vue&type=script&lang=ts"
export * from "./ServerStatus.vue?vue&type=script&lang=ts"

import "./ServerStatus.vue?vue&type=style&index=0&id=cf994ca2&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__